// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CJeR","label":"styles_label__2Qunn"};